import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

const Base64ViewerModal = ({ open, onClose, base64 }) => {
  const [blobUrl, setBlobUrl] = useState(null);

  useEffect(() => {
    if (!base64 || !open) return;

    try {
      // Example base64: data:application/pdf;base64,xxxx
      const parts = base64.split(",");
      const mime = parts[0].match(/:(.*?);/)[1];
      const byteString = atob(parts[1]);

      const arrayBuffer = new ArrayBuffer(byteString.length);
      const uintArray = new Uint8Array(arrayBuffer);

      for (let i = 0; i < byteString.length; i++) {
        uintArray[i] = byteString.charCodeAt(i);
      }

      const blob = new Blob([uintArray], { type: mime });
      const url = URL.createObjectURL(blob);
      setBlobUrl(url);

      return () => {
        URL.revokeObjectURL(url);
      };
    } catch (err) {
      console.error("Base64 render error:", err);
    }
  }, [base64, open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="relative bg-white w-[95%] h-[90%] rounded-xl shadow-xl overflow-hidden">
        
        {/* Header */}
        <div className="flex justify-between items-center px-4 py-3 border-b">
          <h3 className="text-sm font-semibold">Document Viewer</h3>
          <button onClick={onClose} className="text-gray-600 hover:text-black">
            <CloseIcon />
          </button>
        </div>

        {/* Viewer */}
        <div className="w-full h-[calc(100%-56px)]">
          {blobUrl && (
            <iframe
              title="Document Viewer"
              src={blobUrl}
              className="w-full h-full border-none"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Base64ViewerModal;
